import { Location } from "../pages/locations/data-view/types";

export const LocationData: Array<Location> = [];
